import { notNullOrEmpty } from "../utils";
import { sinceIntervals } from "./schema";
export const buildComputedPropertiesFromSubstitutions = (substitutions)=>{
    const eventNames = sinceIntervals.flatMap((interval)=>substitutions.filter((s)=>s.value.includes(`${interval.toLowerCase()}Since_`) || s.freeTrialValue?.includes(`${interval.toLowerCase()}Since_`)).flatMap((s)=>[
                s.value,
                s.freeTrialValue
            ]).filter(notNullOrEmpty).flatMap((s)=>{
            const exp = new RegExp(`\\{\\{\\s*device(\\.${interval.toLowerCase()}Since_(?<eventName>.*?)|\\[(\\'|\\")${interval.toLowerCase()}Since_(?<eventName2>.*?)(\\'|\\")\\])\\s*\\}\\}`, "g");
            const matches = Array.from(s.matchAll(exp));
            if (!matches) {
                return undefined;
            }
            return matches.flatMap((m)=>m.groups?.eventName || m.groups?.eventName2);
        }).filter(notNullOrEmpty).map((eventName)=>({
                type: `${interval}_SINCE`,
                event_name: eventName
            })));
    return eventNames;
};
